import React from 'react';
import LoadingSpinner from '../common/LoadingSpinner';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'text';
    size?: 'sm' | 'md' | 'lg';
    disabled?: boolean;
    fullWidth?: boolean;
    isLoading?: boolean;
    children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
    variant = 'primary',
    size = 'md',
    disabled = false,
    fullWidth = false,
    isLoading = false,
    className = '',
    children,
    ...props
}) => {
    const baseStyles = 'rounded-lg transition-all duration-300 font-medium relative';
    
    const variantStyles = {
        primary: `bg-brand-primary text-text-button hover:bg-brand-hover ${disabled || isLoading ? 'opacity-50 cursor-not-allowed' : 'shadow-brand'}`,
        secondary: `bg-bg-secondary border border-border-primary text-text-primary 
            ${disabled || isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:border-brand-primary hover:bg-hover-bg'}`,
        text: `text-text-primary ${disabled || isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:text-brand-primary'}`
    };

    const sizeStyles = {
        sm: 'px-4 py-2 text-sm',
        md: 'px-6 py-3 text-base',
        lg: 'px-8 py-4 text-lg'
    };

    const widthStyle = fullWidth ? 'w-full' : '';

    // Unified spinner using LoadingSpinner component
    return (
        <button
            className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyle} ${className} ${isLoading ? 'flex items-center justify-center' : ''}`}
            disabled={disabled || isLoading}
            {...props}
        >
            {isLoading && (
                <div className="mr-2">
                    <LoadingSpinner size="sm" color="currentColor" />
                </div>
            )}
            <span className={isLoading ? 'opacity-75' : ''}>{children}</span>
        </button>
    );
};

export default Button;
